export default __webpack_public_path__ + "static/media/icon_Alternate File_.630cd677.svg";